export default "__VITE_ASSET__CuC2zXYq__"